import Iconlogo from "@/assets/icon-logo.webp";
import { AppStoreButton, GooglePlayWhiteButton } from "@/components/store-buttons";
import { DOWNLOAD_LINK } from "@/lib/constants";

function CallToAction() {
  return (
    <section id="final-cta" className="px-5 py-24 sm:px-20">
      <div className="bg-gradient flex-gap-md  container mx-auto flex flex-col items-center justify-center rounded-4xl p-5 py-16 shadow-lg sm:p-24">
        <div className=" section-heading">
          {/* Logo */}
          <div className="flex items-center justify-center">
            <img
              id="icon-logo"
              src={Iconlogo}
              fetchPriority="low"
              alt="Sakeena Logo"
              width={44}
              height={44}
            />
          </div>
          <h2 className="text-center text-3xl font-normal sm:text-5xl">
            A better way to search is here
          </h2>

          <p className="body-text text-center">
            Download Sakeena to seek marriage through trust, presence, and intention, the way it deserves to be sought.
          </p>
        </div>
        <div className=" flex w-full max-w-md  flex-wrap items-center justify-center gap-3 ">
          {/* <WaitListForm /> */}
         <GooglePlayWhiteButton href={DOWNLOAD_LINK.PLAY_STORE_LINK} />
          <AppStoreButton href={DOWNLOAD_LINK.APP_STORE_LINK} /> 
        </div>

     
      </div>
    </section>
  );
}

export default CallToAction;
